import React, { Component } from 'react';
import { ErrorMonitorContext } from './ErrorMonitorProvider';
export class ErrorMonitorBoundary extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { error: null, componentStack: null };
        const errorMonitorFromProps = this.props.errorMonitor;
        const errorMonitorFromProvider = this.context;
        if (errorMonitorFromProps) {
            this.errorMonitorInstance = errorMonitorFromProps;
        }
        else if (errorMonitorFromProvider) {
            this.errorMonitorInstance = errorMonitorFromProvider;
        }
        else {
            throw new Error('ErrorMonitor instance is not available.\n Please wrap with ErrorMonitorProvider OR pass ErrorMonitor to the props of <ErrorMonitorBoundary>\n');
        }
    }
    componentDidCatch(error, { componentStack }) {
        this.errorMonitorInstance.captureException(error, {
            contexts: { react: { componentStack, reactVersion: React.version } },
        });
        // Catch errors in any components below and re-render with error message
        this.setState({
            error,
            componentStack,
        });
    }
    render() {
        const { fallback, isDebug } = this.props;
        const { componentStack, error } = this.state;
        if (componentStack) {
            if (isDebug) {
                console.group?.('ErrorMonitor::Debug:: Error caught in boundary');
                console.warn?.('Error:\n', error);
                console.warn?.('ComponentStack:\n', componentStack);
                console.warn?.('Fallback:\n', fallback);
                console.groupEnd?.();
            }
            return fallback;
        }
        // Normally, just render children
        return this.props.children;
    }
}
ErrorMonitorBoundary.contextType = ErrorMonitorContext;
//# sourceMappingURL=ErrorMonitorBoundary.js.map